__turbopack_context__.v({
  "author": "WClientTestimonials-module__Gwmsqq__author",
  "authorMeta": "WClientTestimonials-module__Gwmsqq__authorMeta",
  "authorName": "WClientTestimonials-module__Gwmsqq__authorName",
  "authorSector": "WClientTestimonials-module__Gwmsqq__authorSector",
  "avatar": "WClientTestimonials-module__Gwmsqq__avatar",
  "avatarImg": "WClientTestimonials-module__Gwmsqq__avatarImg",
  "avatarInitials": "WClientTestimonials-module__Gwmsqq__avatarInitials",
  "controls": "WClientTestimonials-module__Gwmsqq__controls",
  "eyebrow": "WClientTestimonials-module__Gwmsqq__eyebrow",
  "heading": "WClientTestimonials-module__Gwmsqq__heading",
  "nextBtn": "WClientTestimonials-module__Gwmsqq__nextBtn",
  "pagination": "WClientTestimonials-module__Gwmsqq__pagination",
  "prevBtn": "WClientTestimonials-module__Gwmsqq__prevBtn",
  "root": "WClientTestimonials-module__Gwmsqq__root",
  "slide": "WClientTestimonials-module__Gwmsqq__slide",
  "swiper": "WClientTestimonials-module__Gwmsqq__swiper",
  "testimonial": "WClientTestimonials-module__Gwmsqq__testimonial",
});
